"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "BaseMemberHelpers", {
    enumerable: true,
    get: function() {
        return BaseMemberHelpers;
    }
});
const _ncError = require("~/helpers/ncError");
let BaseMemberHelpers = class BaseMemberHelpers {
    async getBaseMember(context, _param, _ncMeta) {
        _ncError.NcError.get(context).invalidRequestBody('Accessing member management api is only available on paid plans. Please upgrade your workspace plan to enable this feature.');
        return undefined;
    }
    constructor(){}
};
